const resources = {
    giftFinder: 'Gift Finder',
    newChat: 'New Chat',
    newChatSeparator: ': '
};

export default function getResource(label) {
    return resources[label];
}
